:host {
  @apply flex;
}

ul {
  @apply inline-flex items-center h-full m-0 p-0;
}

:host([layout="vertical"]) ul {
  @apply flex flex-col w-full;
}

@include base-component();
